export default __webpack_public_path__ + "static/media/pencil-000000.372bf1c0.svg";